"use strict";
ui.loadTemplateFile("quickbar.html");

class QuickBarDialog extends Dialog {
    static SLOTS_PER_BAR = 12;

    _element: any;
    _titleBar: any;
    _slotsContainer: any;
    _startIndex: number;
    _slots: any[];
    _hotIcons: any;

    constructor(hotIcons: any, startIndex: any) {
        super("quickbar.html");

        this._slotsContainer = this._element.children(".slots");
        this._startIndex = startIndex;
        this._slots = [];
        this._hotIcons = [];

        for (let i = 0; i < QuickBarDialog.SLOTS_PER_BAR; ++i) {
            const id = ".quick-slot-" + (i + startIndex);
            let slot = ui.iconslot(id);
            const index = this._slots.length;
            slot.acceptsAll(true);
            slot.on("swap", this._swapSlot.bind(this, index));
            this._slots.push(slot);
            this._slotsContainer.append(slot._element);
        }

        this.centerX();

        this._hotIcons = hotIcons;
        MC.skills.on("changed", this._update.bind(this));
        MC.inventory.on("changed", this._update.bind(this));
        this._hotIcons.on("changed", this._update.bind(this));
        this._update();
    }

    _swapSlot(src: number, dst: string) {
        const sourceIndex = this._startIndex + src;
        const source = this._hotIcons.icons[sourceIndex];
        if (!source || source.type === HOT_ICON_TYPE.EMPTY) return;

        const match = /^quick-slot-(\d+)$/.exec(dst);
        if (match) {
            const destinationIndex = Number(match[1]);
            if (destinationIndex === sourceIndex || destinationIndex >= this._hotIcons.icons.length) return;

            const destination = this._hotIcons.icons[destinationIndex];
            netGame.setHotIcon(destinationIndex, source.type, source.slot);
            netGame.setHotIcon(sourceIndex, destination.type, destination.slot);
        } else if (dst === "drop") {
            netGame.setHotIcon(sourceIndex, HOT_ICON_TYPE.EMPTY, 0);
        }
    }

    useSlot(index: number) {
        if (index < 0 || index >= this._slots.length) {
            return;
        }
        this._slots[index].use();
    }

    _update() {
        for (let i = 0; i < this._slots.length; ++i) {
            const hotIcon = this._hotIcons.icons[this._startIndex + i];
            this._slots[i].clear();
            if (!hotIcon) continue;
            const type = hotIcon.type;
            const slot = hotIcon.slot;
            let icon;

            switch (type) {
                case HOT_ICON_TYPE.EMPTY:
                    break;
                case HOT_ICON_TYPE.ITEM:
                    icon = MC.inventory.findBySlot(slot);
                    break;
                case HOT_ICON_TYPE.SKILL:
                    icon = MC.skills.findBySlot(slot);
                    break;
                case HOT_ICON_TYPE.COMMAND:
                case HOT_ICON_TYPE.EMOTE:
                case HOT_ICON_TYPE.DIALOG:
                case HOT_ICON_TYPE.CLAN_SKILL:
                default:
                    console.warn("Unhandled HOT_ICON_TYPE", type);
            }

            if (icon) {
                this._slots[i].setIcon(type, icon);
            }
        }
    }
}

ui.QuickBarDialog = QuickBarDialog;

ui.quickBarDialog = function (hotIcons: any) {
    return new ui.QuickBarDialog(hotIcons, 0);
};
